import AuthContext from './auth-context';
import React from 'react';

export function withAuth(Component) {
    return function AuthComponent(props) {
        return (
            <AuthContext.Consumer>
                {(auth) => <Component {...props} {...auth}/>}
            </AuthContext.Consumer>
        );
    };
}

export default withAuth;


// WEBPACK FOOTER //
// ./src/universal/components/auth/with-auth.js